<template>
  <div id="map-container" style="text-align: center;">
    <el-button type="text"
               size="mini"
               style="position: absolute; margin-top: -31.5px; margin-left: -66px; color: #A0BE03"
               @click="aprietame"
               icon="el-icon-map-location">
      <span v-if="!selecting" style="font-size: 11px;">SELECCIÓN MÚLTIPLE</span>
      <span v-else style="font-size: 11px;">SELECCIÓN MÚLTIPLE ACTIVADA</span>
    </el-button>
    <div v-bind:class="{loader:true, done:!loading}" >
      <div class="indeterminate"></div>
    </div>
    <div id="route-map" v-bind:style="{ height }"></div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import GoogleMapsLoader from './config';
import { TaskQueue } from '../../../mixins/taskQueue';

export default {
  name: 'MapRoutesMultipleV2',
  props: {
    lat: {
      type: Number,
      default: -33.435774,
    },
    lng: {
      type: Number,
      default: -70.660690,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    locations: {
      type: Array,
      default() {
        return [];
      },
    },
    selection: {
      type: Array,
      default() {
        return [];
      },
    },
    height: {
      type: String,
      default: '100vh',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  data() {
    return {
      clustering: [],
      google: null,
      infoWindows: [],
      map: null,
      taskLen: 0,
      markers: [],
      colorRouletteIndex: 0,
      colorRoulette: [
        '#3c51da',
        '#ef5fdd',
        '#00e8b1',
        '#deae00',
        '#ff6500',
        '#982bc5',
        '#ab3a04',
        '#607d8b',
        '#ff4c4c',
        '#8b5aff',
        '#ca7b4c',
        '#795548',
        '#009688',
        '#ff9a9a',
        '#10d0e8',
      ],
      colors: [
        { default: '#fd8f3e', selected: '#5a3316' },
        { default: '#AAD500', selected: '#3e4b00' },
        { default: '#00bce8', selected: '#004f5e' },
        { default: '#e475f6', selected: '#692f64' },
        { default: '#8d674e', selected: '#5b4033' },
        { default: '#4662ff', selected: '#2a3791' },
        { default: '#25d076', selected: '#166e48' },
        { default: '#fd5252', selected: '#732a2a' },
        { default: '#814afa', selected: '#3a1883' },
        { default: '#e0c828', selected: '#605514' },
      ],
      routeColors: [],
      routes: [],
      taskQueue: new TaskQueue(211),
      mouseDownPos: null,
      gribBoundingBox: null,
      mouseIsDown: 0,
      selecting: false,
      shiftPressed: false,
      style: [{
        elementType: 'geometry',
        stylers: [{ color: '#f5f5f5' }],
      }, {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'true' }],
      }, {
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#f5f5f5' }],
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }],
      }, {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }],
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#eaf4fe' }],
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }],
    };
  },
  mounted() {
    this.initMap().then(async () => {
      if (this.locations.length > 0) {
        await this.setMarkers();
        this.emitSelected();
      }
    });
  },
  watch: {
    async selection(newVal, old) {
      if (newVal.length > 0) {
        let itsDifferent = false;
        if (newVal.length === old.length) {
          let allIn = true;
          newVal.forEach((s) => {
            allIn = allIn && old.filter(os => os === s);
          });
          if (!allIn) {
            itsDifferent = true;
          }
        } else {
          itsDifferent = true;
        }
        if (itsDifferent) {
          await this.setMarkers();
          this.emitSelected();
        }
      }
    },
    locations(newVal, old) {
      if (old.length > 0) {
        this.taskQueue.enqueue().then(() => {
          this.taskLen += 1;
          const rems = old.filter(r => !newVal.reduce((a, v) => v.id === r.id || a, false));
          rems.forEach((r) => {
            this.delRoutes(r.id);
            this.delMarkers(r.id);
            if (!this.colors.map(c => c.default).includes(r.color)) this.colors.push(r.color);
          });
          this.emitSelected();
          if (rems.length > 0) {
            this.updateStatusBar();
          }
        });
      }
      if (newVal.length > 0) {
        this.taskQueue.enqueue().then(async () => {
          this.taskLen += 1;
          const adds = newVal.filter(r => !old.reduce((a, v) => v.id === r.id || a, false));
          if (adds.length > 0) {
            adds.forEach((a) => {
              this.locations.find(l => l.id === a.id).color = this.getColor();
            });
            await this.setMarkers();
          } else {
            this.updateStatusBar();
          }
        });
      }
    },
  },
  methods: {
    getMarker(color = '#c6f900') {
      return {
        scale: 1,
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#272727',
        strokeOpacity: 0.1,
        fillColor: color,
        path: 'M-1.2,20C-9.9,6.4-11.6,5-11.6,0c0-6.9,5.2-12.4,11.6-12.4S11.6-6.9,11.6,0c0,5-1.6,6.4-10.4,20C0.6,20.9-0.6,20.9-1.2,20L-1.2,20z',
      };
    },
    initMap() {
      return new Promise((resolve) => {
        if (this.map) {
          this.markers.forEach((m) => {
            m.setMap(null);
          });
          this.markers.length = 0;
          resolve();
        } else {
          const element = document.getElementById('route-map');
          GoogleMapsLoader.load((google) => {
            this.google = google;
            this.map = new google.maps.Map(element, {
              center: new google.maps.LatLng(this.lat, this.lng),
              zoom: 8,
              mapTypeControl: false,
              streetViewControl: false,
              styles: this.style,
            });
            this.controlDiv = document.createElement('div');
            this.controlDiv.style.display = 'none';
            const controlUI = document.createElement('div');
            controlUI.style.backgroundColor = '#707070';
            controlUI.style.border = '2px solid #707070';
            controlUI.style.borderRadius = '3px';
            controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
            controlUI.style.cursor = 'pointer';
            controlUI.style.marginBottom = '22px';
            controlUI.style.marginTop = '10px';
            controlUI.style.textAlign = 'center';
            controlUI.style.width = '200px';
            this.controlDiv.appendChild(controlUI);
            // Set CSS for the control interior.
            const controlText = document.createElement('div');
            controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
            controlText.style.fontSize = '16px';
            controlText.style.color = 'white';
            controlText.style.lineHeight = '20px';
            controlText.innerHTML = 'Cargando Rutas';
            controlUI.appendChild(controlText);
            this.controlDiv.index = 1;
            this.controlPB = document.createElement('div');
            this.controlPB.style.backgroundColor = '#a7d500';
            this.controlPB.style.height = '10px';
            this.controlPB.style.width = '6%';
            controlUI.appendChild(this.controlPB);
            this.controlDiv.index = 1;
            this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.controlDiv);
            google.maps.event.addListener(this.map, 'mousemove', (e) => {
              // eslint-disable-next-line
              if (this.mouseIsDown && (this.selecting || this.shiftPressed || this.gribBoundingBox != null) ) {
                if (this.gribBoundingBox !== null) {
                  const newbounds = new google.maps.LatLngBounds(this.mouseDownPos, null);
                  newbounds.extend(e.latLng);
                  this.gribBoundingBox.setBounds(newbounds);
                } else {
                  this.gribBoundingBox = new google.maps.Rectangle({
                    map: this.map,
                    bounds: null,
                    fillOpacity: 0.15,
                    strokeWeight: 0.9,
                    clickable: false,
                  });
                }
              }
            });
            google.maps.event.addListener(this.map, 'mousedown', (e) => {
              if (this.selecting || this.shiftPressed) {
                this.mouseIsDown = 1;
                this.mouseDownPos = e.latLng;
                this.map.setOptions({
                  draggable: false,
                });
              }
            });
            // aqui emp
            google.maps.event.addListener(this.map, 'mouseup', () => {
              // eslint-disable-next-line
              if (this.mouseIsDown && (this.selecting || this.shiftPressed|| this.gribBoundingBox != null)) {
                this.mouseIsDown = 0;
                if (this.gribBoundingBox !== null) {
                  // eslint-disable-next-line
                  // const boundsSelectionArea = new google.maps.LatLngBounds(this.gribBoundingBox.getBounds().getSouthWest(), this.gribBoundingBox.getBounds().getNorthEast());
                  const multiSelection = [];
                  this.markers.forEach((mark, i) => {
                    if (this.gribBoundingBox.getBounds().contains(mark.getPosition())) {
                      if (mark.kind === 'DP') {
                        // eslint-disable-next-line
                        mark.pointData.forEach((dp)=>{
                          multiSelection.push(dp);
                        });
                        this.markers[i].selected = !mark.selected;
                        if (mark.selected) {
                          if (mark.hasPosition) {
                            this.markers[i].setIcon(this.getMarker(this.markers[i].color.selected));
                            // this.markers[i].setIcon(this.getMarker('#4f7cf9'));
                            // this.markers[i]
                            // .setIcon(`${require('../../../assets/img/blue_marker.png')}`);
                          } else {
                            this.markers[i].setIcon(this.getMarker(this.markers[i].color.selected));
                            // this.markers[i].setIcon(this.getMarker('#f9525f'));
                            // this.markers[i]
                            // .setIcon(`${require('../../../assets/img/red_marker.png')}`);
                          }
                          this.markers[i].setZIndex(100 + i);
                        } else {
                          if (mark.hasPosition) {
                            mark.setIcon(this.getMarker(mark.color.default));
                            // mark.setIcon(this.getMarker('#c6f900'));
                            // mark.setIcon(`${require('../../../assets/img/green_marker.png')}`);
                          } else {
                            mark.setIcon(this.getMarker(mark.color.default));
                            // mark.setIcon(this.getMarker('#9552f9'));
                            // mark.setIcon(`${require('../../../assets/img/purple_marker.png')}`);
                          }
                          this.markers[i].setZIndex(10 + i);
                        }
                      }
                    }
                  });
                  if (multiSelection.length > 0) {
                    this.emitSelected();
                  }
                  this.gribBoundingBox.setMap(null); // remove the rectangle
                }
                this.gribBoundingBox = null;
                this.selecting = false;
              } else {
                this.map.setOptions({
                  draggable: true,
                });
              }
              // stopDraw(e);
            });
            resolve();
          });
        }
      });
    },
    reRenderMap() {
      if (this.markers.length > 0) {
        this.taskLen += 1;
        this.taskQueue.enqueue().then(async () => {
          this.markers.forEach((m) => {
            m.setMap(null);
          });
          this.markers.length = 0;
          this.routes.forEach((r) => {
            r.setMap(null);
          });
          this.routes.length = 0;
          this.updateStatusBar();
          await this.setMarkers();
          this.emitSelected();
        });
      }
    },
    aprietame() {
      this.selecting = !this.selecting;
    },
    checkIfExists(routeId, lat, lng) {
      const marks = this.markers.filter(m => m.kind === 'DP'
        && m.routes_id === routeId);
      const match = marks.filter(m => m.pointData[0].point.latitude === lat
        && m.pointData[0].point.longitude === lng);
      const exists = marks.reduce((acc, el) => acc + el.pointData.length, 0);
      return match.length > 0 ? [match[0], exists] : [null, 0];
    },
    getColor() {
      // if (this.routeColors.length === 0) this.routeColors = this.colors;
      return this.colors.splice(0, 1)[0];
    },
    async setMarkers() {
      this.taskLen = 0;
      // this.markers = [];
      for (let i = 0; i < this.locations.length; i += 1) {
        const route = this.locations[i];
        const draw = this.routes.filter(r => r.routes_id === route.id).length === 0;
        if (draw) {
          await this.taskQueue.enqueue().then(async () => {
            this.taskLen += 1;
            const drawable = [];
            const latOrigin = route.transfer_center
              ? route.transfer_center.point.latitude : route.distribution_center.point.latitude;
            const lonOrigin = route.transfer_center
              ? route.transfer_center.point.longitude : route.distribution_center.point.longitude;
            if (this.markers.filter(m => !m.kind
              && ['CD', 'CTT'].includes(m.title)
              && m.pointData.id === route.distribution_center.id).length === 0) {
              this.markers.push(this.createCTMarker(route));
            }
            for (let j = 0; j < route.delivery_points.length; j += 1) {
              let plate = route.vehicle;
              if (!plate) {
                plate = '-';
              }
              const newMarker = this.createDPMarker(
                route.delivery_points.length,
                route.delivery_points[j],
                plate,
                route.id,
                this.locations[i].color,
              );
              if (newMarker) {
                this.markers.push(newMarker);
                if (route.delivery_points[j].route_position !== null && draw) {
                  drawable.push(route.delivery_points[j]);
                }
              }
            }
            if (drawable.length > 0 && draw) {
              const splits = this.createSplitRoutes(drawable, latOrigin, lonOrigin);
              this.taskLen += splits.length;
              // eslint-disable-next-line no-loop-func
              const self = this;
              // const color = this.getRandomColor();
              // eslint-disable-next-line no-loop-func
              var kmdrafout = 0
              var km = ""
              for (const path of splits) {
                await this.taskQueue.enqueue().then(async () => {
                  const r = path;
                  const options = {
                    provideRouteAlternatives: false,
                    optimizeWaypoints: false,
                    unitSystem: this.google.maps.UnitSystem.METRIC,
                    drivingOptions: {
                      departureTime: new Date(Date.now()),
                      trafficModel: 'optimistic'
                    },
                    travelMode: 'DRIVING',
                    origin: r.origin,
                    destination: r.destination,
                    waypoints: r.waypoints,
                  };
                  if (!self.directionService) {
                    self.directionService = new self.google.maps.DirectionsService();
                  }
                  self.directionService.route(options, (response, status) => {
                    if (status === 'OK') {
                      if (self.routes === undefined) {
                        self.routes = [];
                      }
                      let kmdraf = 0
                      response.routes.forEach((elem) => {
                        elem.legs.forEach((tramos) => {
                          kmdraf = kmdraf + tramos.distance.value
                        })
                      })
                      kmdrafout = kmdrafout + kmdraf
                      self.infoWindows.push(new self.google.maps.InfoWindow());
                      self.routes.push(new self.google.maps.DirectionsRenderer({
                        routes_id: route.id,
                        preserveViewport: true,
                        draggable: false,
                        map: self.map,
                        directions: response,
                        // infoWindow: self.infoWindows[index],
                        suppressMarkers: true,
                        polylineOptions: {
                          strokeColor: route.color.default,
                          strokeOpacity: 0.8,
                          strokeWeight: 3,
                        },
                      }));
                    } else {
                      self.$notify.error({
                        title: 'Error',
                        message: 'Problemas al visualizar la ruta',
                      });
                    }
                    if (splits.length === 1){
                      km = (kmdrafout / 1000).toFixed(1) + " km";
                      this.$root.$emit("route-messure", km + "/" + route.id)
                    }
                    this.updateStatusBar();
                  });
                });

              }
              if (splits.length > 1){
                km = (kmdrafout / 1000).toFixed(1) + " km";
                this.$root.$emit("route-messure", km + "/" + route.id)
              }
            }
          });
        }
      }
      this.taskQueue.enqueue().then(() => {
        this.taskLen += 1;
        const bounds = new this.google.maps.LatLngBounds();
        this.markers.forEach(m => bounds.extend(m.getPosition()));
        this.map.fitBounds(bounds);
        this.updateStatusBar();
      });
    },
    updateStatusBar() {
      this.controlPB.style.width = `${((this.taskLen - this.taskQueue.tasks.length) / this.taskLen) * 100}%`;
      if (this.taskQueue.tasks.length === 0) {
        window.setTimeout(() => {
          this.controlDiv.style.opacity = '75%';
          window.setTimeout(() => {
            this.controlDiv.style.opacity = '50%';
            window.setTimeout(() => {
              this.controlDiv.style.opacity = '25%';
              window.setTimeout(() => {
                this.controlDiv.style.opacity = '5%';
                window.setTimeout(() => {
                  this.controlDiv.style.display = 'none';
                  this.controlDiv.style.opacity = '100%';
                  this.controlPB.style.width = '0%';
                }, 50);
              }, 50);
            }, 50);
          }, 50);
        }, 300);
      } else {
        this.controlDiv.style.display = 'block';
      }
    },
    createCTMarker(route) {
      let ctTitle = 'CD';
      let ctPointData = route.distribution_center;
      let lat = route.distribution_center.point.latitude;
      let lon = route.distribution_center.point.longitude;
      if (route.transfer_center) {
        lat = route.transfer_center.point.latitude;
        lon = route.transfer_center.point.longitude;
        ctTitle = 'CTT';
        ctPointData = route.transfer_center;
      }
      return new this.google.maps.Marker({
        title: ctTitle,
        position: new this.google.maps.LatLng(lat, lon),
        map: this.map,
        icon: {
          url: `${require('../../../assets/img/depot.png')}`,
          anchor: new this.google.maps.Point(13, 20),
        },
        pointData: ctPointData,
        routes_id: route.id,
      });
    },
    createDPMarker(len, dp, plate, routesId, color) {
      const tempDP = JSON.parse(JSON.stringify(dp));
      tempDP.plate = plate;
      const othersMarker = this.checkIfExists(
        routesId,
        tempDP.point.latitude,
        tempDP.point.longitude,
      );
      const isSelected = this.selection.filter(s => s === tempDP.code).length !== 0;
      /*
      let iconMarker = `${(tempDP.route_position !== null)
        ? require('../../../assets/img/green_marker_shadow.png')
        : require('../../../assets/img/purple_marker.png')}`;
      if (isSelected) {
        iconMarker = `${(tempDP.route_position !== null)
          ? require('../../../assets/img/blue_marker.png')
          : require('../../../assets/img/red_marker.png')}`;
      }
      */
      // let markerColor = tempDP.route_position !== null ? '#c6f900' : '#9552f9';
      // if (isSelected) markerColor = tempDP.route_position !== null ? '#4f7cf9' : '#f9525f';
      const markerColor = isSelected ? color.selected : color.default;
      const iconMarker = this.getMarker(markerColor);
      if (othersMarker[0] === null) {
        const marker = new this.google.maps.Marker({
          // title: `${(tempDP.route_position !== null) ? tempDP.route_position + 1 : 'LE'}`,
          position: new this.google.maps.LatLng(tempDP.point.latitude, tempDP.point.longitude),
          // label: `${(tempDP.route_position !== null) ? tempDP.route_position + 1 : 'LE'}`,
          label: {
            text: `${(tempDP.route_position !== null) ? tempDP.route_position + 1 : 'LE'}`,
            color: 'white',
            fontSize: '12px',
          },
          map: this.map,
          icon: iconMarker,
          color,
          pointData: [JSON.parse(JSON.stringify(tempDP))],
          selected: isSelected,
          hasPosition: tempDP.route_position !== null,
          kind: 'DP',
          routes_id: routesId,
        });
        marker.addListener('click', () => {
          if (marker.selected) {
            marker.selected = false;
            if (marker.hasPosition) {
              marker.setIcon(this.getMarker(color.default));
              // marker.setIcon(this.getMarker('#c6f900'));
              // marker.setIcon(`${require('../../../assets/img/green_marker.png')}`);
            } else {
              marker.setIcon(this.getMarker(color.default));
              // marker.setIcon(`${require('../../../assets/img/purple_marker.png')}`);
            }
            marker.setZIndex(null);
            this.emitSelected();
            marker.setZIndex(10);
          } else {
            marker.selected = true;
            if (marker.hasPosition) {
              marker.setIcon(this.getMarker(color.selected));
              // marker.setIcon(`${require('../../../assets/img/blue_marker.png')}`);
            } else {
              marker.setIcon(this.getMarker(color.selected));
              // marker.setIcon(`${require('../../../assets/img/red_marker.png')}`);
            }
            marker.setZIndex(100);
            this.emitSelected();
          }
        });
        return marker;
      }
      if (othersMarker[0].selected !== isSelected && isSelected) {
        othersMarker[0].selected = isSelected;
        if (othersMarker[0].hasPosition) {
          othersMarker[0].setIcon(this.getMarker(color.selected));
          // othersMarker[0].setIcon(`${require('../../../assets/img/blue_marker.png')}`);
        } else {
          othersMarker[0].setIcon(this.getMarker(color.selected));
          // othersMarker[0].setIcon(`${require('../../../assets/img/red_marker.png')}`);
        }
      }
      if (len > othersMarker[1]) {
        othersMarker[0].pointData.push(JSON.parse(JSON.stringify(tempDP)));
      }
      return null;
    },
    createSplitRoutes(drawablePoints, latOrigin, lonOrigin) {
      const lastPoint = drawablePoints.sort((a, b) => b.route_position - a.route_position)[0];
      if (drawablePoints.length <= 20) {
        return [{
          origin: new this.google.maps.LatLng(latOrigin, lonOrigin),
          destination: new this.google.maps.LatLng(
            lastPoint.point.latitude,
            lastPoint.point.longitude,
          ),
          waypoints: drawablePoints.sort(
            (pA, pB) => pA.route_position - pB.route_position,
          ).map(point => ({
            location: new this.google.maps.LatLng(
              point.point.latitude,
              point.point.longitude,
            ),
            stopover: true,
          })),
        }];
      }
      let splits = [];
      const dps = drawablePoints.sort((a, b) => a.route_position - b.route_position);
      let twenties = [];
      for (let i = 0; i < dps.length; i += 1) {
        twenties.push(dps[i]);
        if (twenties.length === 20) {
          splits.push(twenties);
          twenties = [];
        }
      }
      if (twenties.length > 0) {
        splits.push(twenties);
      }
      const semiroute = [];
      splits = splits.filter(s => s.length > 0);
      for (let i = 0; i < splits.length; i += 1) {
        // eslint-disable-next-line max-len)
        semiroute.push({
          origin: new this.google.maps.LatLng(
            // eslint-disable-next-line max-len,no-undef
            i === 0 ? latOrigin : splits[i - 1][splits[i - 1].length - 1].point.latitude,
            // eslint-disable-next-line max-len
            i === 0 ? lonOrigin : splits[i - 1][splits[i - 1].length - 1].point.longitude,
          ),
          destination: new this.google.maps.LatLng(
            // eslint-disable-next-line max-len
            i + 1 === splits.length ? lastPoint.point.latitude : splits[i + 1][0].point.latitude,
            // eslint-disable-next-line max-len
            i + 1 === splits.length ? lastPoint.point.longitude : splits[i + 1][0].point.longitude,
          ),
          waypoints: splits[i].sort(
            (pA, pB) => pA.route_position - pB.route_position,
          ).map(point => ({
            location: new this.google.maps.LatLng(
              point.point.latitude,
              point.point.longitude,
            ),
            stopover: true,
          })),
        });
      }
      return semiroute;
    },
    getRandomColor() {
      // eslint-disable-next-line no-plusplus
      return this.colorRoulette[this.colorRouletteIndex++ % this.colorRoulette.length];
    },
    delMarkers(routeId) {
      this.markers.forEach((m) => {
        if (m.routes_id === routeId) {
          m.setMap(null);
        }
      });
      this.markers = this.markers.filter(rd => rd.routes_id !== routeId);
    },
    delRoutes(routeId) {
      this.routes.filter(rd => rd.routes_id === routeId).forEach(d => d.setMap(null));
      this.routes = this.routes.filter(rd => rd.routes_id !== routeId);
    },
    selectRoute(routeId) {
      const routeMarkers = this.markers.filter(rd => rd.routes_id === routeId && rd.kind === 'DP');
      const allAlreadySelected = routeMarkers.reduce((acc, m) => acc && m.selected, true);
      routeMarkers.forEach((marker, i) => {
        if (allAlreadySelected) {
          // eslint-disable-next-line no-param-reassign
          marker.selected = false;
          if (marker.hasPosition) {
            marker.setIcon(this.getMarker(marker.color.default));
            // marker.setIcon(this.getMarker('#c6f900'));
            // marker.setIcon(`${require('../../../assets/img/green_marker.png')}`);
          } else {
            marker.setIcon(this.getMarker(marker.color.default));
            // marker.setIcon(this.getMarker('#9552f9'));
            // marker.setIcon(`${require('../../../assets/img/purple_marker.png')}`);
          }
          marker.setZIndex(10 + i);
        } else {
          // eslint-disable-next-line no-param-reassign
          marker.selected = true;
          if (marker.hasPosition) {
            marker.setIcon(this.getMarker(marker.color.selected));
            // marker.setIcon(this.getMarker('#4f7cf9'));
            // marker.setIcon(`${require('../../../assets/img/blue_marker.png')}`);
          } else {
            marker.setIcon(this.getMarker(marker.color.selected));
            // marker.setIcon(this.getMarker('#f9525f'));
            // marker.setIcon(`${require('../../../assets/img/red_marker.png')}`);
          }
          marker.setZIndex(100 + i);
        }
      });
      this.emitSelected();
    },
    emitSelected() {
      this.$emit('input', this.markers
        .map(m => (m.kind === 'DP' && m.selected
          ? m.pointData.map(dp => Object.assign(JSON.parse(JSON.stringify(dp)),
            { routes_id: m.routes_id, plate: dp.plate })) : []))
        .filter(s => s.length > 0)
        .reduce((a, v) => a.concat(v), []));
    },
  },
};
</script>

<style scoped>

</style>
